export const featureSwagLocker = "swag_locker";
export const featureSwagKits = "swag_kits";
export const featureSharedShops = "shared_shops";
export const featureSharedSwagDesigns = "shared_swag_designs";
export const featureTeamWallet = "team_wallet";
export const featureShopIntegrations = "integrations";
export const featureCampaigns = "campaigns";
export const featureP2p = "p2p";
export const featureCustomReporting = "custom_reporting";
export const featureShopCustomization = "shop-customization";
export const featureCoreCollection = "core_collections";

//PACKAGE FEATURES INTENT
export const featureSwagLockerIntent = "swag_locker";
export const featureSwagKitsIntent = "swag_kits";
export const featureSharedShopsIntent = "shared_shops";
export const featureSharedSwagDesignsIntent = "shared_swag_designs";
export const featureTeamWalletIntent = "team_wallet";
export const featureShopIntegrationsIntent = "integrations";
export const featureCampaignsIntent = "campaigns";
export const featureP2pPackageIntent = "p2p_recognition";
export const featureShopCustomizationIntent = "shop_customization";
export const featureSnackBoxesIntent = "snacks"; // This intent is not available in the packages features API; it's only for the frontend.

export const featureLocker = "lockers";
export const featureKits = "kits";
export const featureShops = "shops";
export const featureSwags = "collections";
export const featureWallet = "wallets";
export const featureReporting = "reportings";
export const featureP2Ps = "p2ps";
export const featureCollections = "collections";
export const featureShopsCustomization = "shop_customizations";
export const featureIntegrations = "integrations";

export const FEATURE_PERMISSIONS = {
  [featureSwagLocker]: featureLocker,
  [featureSwagKits]: featureKits,
  [featureSharedSwagDesigns]: featureSwags,
  [featureSharedShops]: featureShops,
  [featureShopCustomization]: featureShopsCustomization,
  [featureTeamWallet]: featureWallet,
  [featureCustomReporting]: featureReporting,
  [featureP2p]: featureP2Ps,
  [featureCoreCollection]: featureCollections,
};

export const workspaceCampaignFeature = "campaigns";
export const workspaceContactsFeature = "contacts";
export const workspaceKitsFeature = "kits";
export const workspaceLockerFeature = "locker";
export const workspaceP2pFeature = "p2p";
export const workspaceSettingsFeature = "settings";
export const workspaceShopsFeature = "shops";
export const workspaceCollectionsFeature = "collections";
export const workspaceIntegrationsFeature = "integrations";
export const workspaceCreateWalletFeature = "wallets";
export const workspaceOrdersFeature = "orders";
export const workspacePointsWalletFeature = "points_wallet";
export const workspaceCatalogsFeature = "catalogs";
export const workspaceAssetLibraryFeature = "asset_library";

export const CREATE_PERMISSION = "create";
export const MANAGE_PERMISSION = "manage";
export const SHARE_PERMISSION = "share";
export const LOCK_PERMISSION = "lock";

export const WORKSPACE_FEATURES_PERMISSIONS = {
  [workspaceCampaignFeature]: {
    [CREATE_PERMISSION]: [featureCampaigns],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureCampaigns],
  },
  [workspaceCollectionsFeature]: {
    [CREATE_PERMISSION]: [featureCollections, featureCoreCollection],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureCollections, featureCoreCollection],
  },
  [workspaceContactsFeature]: {
    [CREATE_PERMISSION]: [workspaceContactsFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureShopIntegrations, workspaceContactsFeature],
  },
  [workspaceKitsFeature]: {
    [CREATE_PERMISSION]: [featureSwagKits],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureSwagKits],
  },
  [workspaceLockerFeature]: {
    [CREATE_PERMISSION]: [featureSwagLocker],
    [SHARE_PERMISSION]: [featureSharedSwagDesigns],
    [MANAGE_PERMISSION]: [featureSwagLocker, featureSharedSwagDesigns],
  },
  [workspaceP2pFeature]: {
    [CREATE_PERMISSION]: [featureP2p, featureP2Ps, workspaceP2pFeature],
    [SHARE_PERMISSION]: [featureP2p, featureP2Ps],
    [MANAGE_PERMISSION]: [featureP2p, featureP2Ps, workspaceP2pFeature],
  },
  [workspaceSettingsFeature]: {
    [CREATE_PERMISSION]: [],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [workspaceSettingsFeature],
  },
  [workspaceShopsFeature]: {
    [CREATE_PERMISSION]: [featureSharedShops, workspaceShopsFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureShops, workspaceShopsFeature],
  },
  [workspaceCreateWalletFeature]: {
    [CREATE_PERMISSION]: [workspaceCreateWalletFeature, featureTeamWallet],
    [SHARE_PERMISSION]: [featureTeamWallet],
    [MANAGE_PERMISSION]: [featureTeamWallet],
  },
  [workspaceIntegrationsFeature]: {
    [CREATE_PERMISSION]: [featureIntegrations, workspaceIntegrationsFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [featureIntegrations, workspaceIntegrationsFeature],
  },
  [workspacePointsWalletFeature]: {
    [CREATE_PERMISSION]: [workspacePointsWalletFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [workspacePointsWalletFeature],
  },
  [workspaceCatalogsFeature]: {
    [CREATE_PERMISSION]: [workspaceCatalogsFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [workspaceCatalogsFeature],
  },
  [workspaceAssetLibraryFeature]: {
    [CREATE_PERMISSION]: [workspaceAssetLibraryFeature],
    [SHARE_PERMISSION]: [],
    [MANAGE_PERMISSION]: [workspaceAssetLibraryFeature],
  },
};

export const FEATURE_MAPPING_TO_WORKSPACE_FEATURES = {
  [featureCampaigns]: workspaceCampaignFeature,
  [featureP2p]: workspaceP2pFeature,
  [featureP2Ps]: workspaceP2pFeature,
  [featureShopCustomization]: workspaceShopsFeature,
  [featureCoreCollection]: workspaceCollectionsFeature,
  [featureCollections]: workspaceCollectionsFeature,
  [featureIntegrations]: workspaceIntegrationsFeature,
  [featureShopIntegrations]: workspaceIntegrationsFeature,
  [featureCustomReporting]: workspaceShopsFeature,
  [featureSwagLocker]: workspaceLockerFeature,
  [featureSwagKits]: workspaceKitsFeature,
  [featureSharedSwagDesigns]: workspaceCollectionsFeature,
  [featureSharedShops]: workspaceShopsFeature,
  [featureTeamWallet]: workspaceCreateWalletFeature,
  [workspaceContactsFeature]: workspaceContactsFeature,
  [workspaceAssetLibraryFeature]: workspaceAssetLibraryFeature,
};

export const TRIAL_PACKAGE_KEY = "trial-business-USD-Yearly";
export const TRIAL_PACKAGE_STATUS = "in_trial";
export const GIFTING_BASIC_INTENT = "gifting_basic";
